module.exports = __webpack_public_path__ + "static/media/PreRegistration.1996500a.svg";